import React, { useContext, useEffect, useState } from 'react';
import { AppContext, ToastrContext } from '../../contexts';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, Checkbox, Flex, Loader, Stack, Text } from '@mantine/core';
import ImagePicker from '../../components/elements/ImagePicker/ImagePicker';
import IconDownloadCsv from '../../components/icons/IconDownloadCsv';
import { MIME_TYPES } from '@mantine/dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { fetchListFeatureMerchant, fetchUpdateFeatureStatusMerchantBulk } from './actions';
import { RenderModalBulkConfirmation, RenderModalLimitMaxCsv, RenderModalSummaryBulkActivation } from './Modal';

const FormBulkActivation = () => {
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const location = useLocation();
  const history = useNavigate();
  const path = location.pathname.split('/').pop();
  const textType = path === 'activation' ? 'Aktifkan' : 'Nonaktifkan';
  const dispatch = useDispatch();
  const { dataListFeatureMerchant,
    isLoadingListFeatureMerchant,
    isLoadingUpdateStatusBulk,
    dataUpdateStatusBulk } = useSelector((state) => state.mapFeatureActivation);

  const [payload, setPayload] = useState({
    file: [],
    id: [],
    isActivated: path === 'activation' ? true : false
  });
  const [modal, setModal] = useState({
    opened: false,
    type: ''
  });

  const downloadTemplate = () => {
    const url = 'https://storage.googleapis.com/fin-map-images-public-stage/templates/template-aktivasi-fitur-MAP.csv';
    const link = document.createElement('a');
    link.href = url;
    link.download = 'template-aktivasi-fitur-MAP.csv';
    link.click();
    link.remove();
  };

  const handleChangeFeature = (value) => {
    setPayload({
      ...payload,
      id: value
    });
  };

  const apiResponseHandler = (response) => {
    if(response.success){
      setModal({
        type: 'summary',
        opened: true
      });
    }else{
      if(response.status === 'CSV_MAX_LIMIT'){
        setModal({
          type: 'limitCsv',
          opened: true
        });
      }
      onCloseModal();
      setToastr({ desc: response.message, type: 'danger', visible: true });
    }
  };

  const handleSubmit = () => {
    const modPayload = {
      ...payload,
      file: payload?.file[0] || null,
      menu: payload?.id || [],
    };
    const bodyFormData = new FormData();
    for(const key in modPayload){
      bodyFormData.append(key, modPayload[key]);
    }
    dispatch(fetchUpdateFeatureStatusMerchantBulk(bodyFormData, apiResponseHandler));
  };

  const onCloseModal = () => {
    setModal({ type: modal.type, opened: false });
  };

  useEffect(() => {
    setBreadcrumbs([{
      to: '/activation-feature-map',
      name: 'Aktivasi Fitur MAP'
    }, `${textType} Fitur MAP di Pangkalan`]);
    dispatch(fetchListFeatureMerchant());
  }, []);

  return (
    <Stack align="center" w="100%" >
      <Card w="40rem" withBorder>
        <ImagePicker accept={[MIME_TYPES.csv]} display="flex" downloadTemplate={downloadTemplate} IconDownloadTemplate={<IconDownloadCsv/>} info={<>File format <span style={{ fontWeight: 600 }}>.csv </span>
           ukuran maksimal <span style={{ fontWeight: 600 }}>2Mb.</span></>}
        onSelect={(file) =>     setPayload({
          ...payload,
          file: file
        })}
        required
        title="File Daftar Pangkalan"
        withDownloadTemplate
        />
        <Text fw={600} mt={24}>{textType} Fitur Pangkalan</Text>
        <Checkbox.Group onChange={handleChangeFeature}>
          <Stack>
            {dataListFeatureMerchant.map((item, idx) => (
              <Checkbox
                key={idx+item.id}
                label={item.menu} styles={{
                  label: {
                    fontWeight: 400,
                    fontSize: 13
                  },
                  body: {
                    alignItems: 'center'
                  }
                }} value={item.id} />
            ))}
          </Stack>
        </Checkbox.Group>
        {isLoadingListFeatureMerchant && <Loader/>}
        <Flex align="center" gap={24} mt={24}>
          <Button fullWidth onClick={() => history(-1)} variant="outline">Kembali</Button>
          <Button disabled={payload.file.length < 1
          || payload.id.length < 1} fullWidth onClick={() => {
            setModal({
              type: 'bulkConfirmation',
              opened: true
            });
          }}>Simpan</Button>
        </Flex>
      </Card>
      {modal.type === 'bulkConfirmation' && <RenderModalBulkConfirmation
        isLoading={isLoadingUpdateStatusBulk}
        listFeature={dataListFeatureMerchant}
        onClose={onCloseModal}
        onConfirm={handleSubmit}
        opened={modal.opened}
        selectedFeature={payload?.id || []}
        type={path}
      />}
      {modal.type === 'summary' && <RenderModalSummaryBulkActivation
        listFeature={dataListFeatureMerchant} onClose={onCloseModal}
        opened={modal.opened}
        selectedFeature={payload?.id || []}
        summary={dataUpdateStatusBulk}
        type={path}
      />}
      {modal.type === 'limitCsv' && <RenderModalLimitMaxCsv
        message={<>Maksimal jumlah pangkalan yang dapat diproses <strong>1.000 pangkalan</strong>
      . Perbarui file daftar pangkalan dan coba lagi.</>}
        onClose={onCloseModal}
        opened={modal.opened}
      />}
    </Stack>
  );
};

export default FormBulkActivation;
